var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        [
          _vm.isContractor
            ? _c("ContractorDocumentInfoProvider", {
                attrs: {
                  currentUser: _vm.currentUser,
                  document: _vm.documents,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ attachedToEntities, processing }) {
                        return [
                          _c("RemoveDocumentModal", {
                            attrs: {
                              attachedToEntities: attachedToEntities,
                              processing: processing,
                              fileName: _vm.document.filename,
                            },
                            on: {
                              cancelled: _vm.hideModal,
                              confirmed: _vm.onConfirm,
                              close: _vm.hideModal,
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  573866587
                ),
              })
            : _c("ManagementDocumentInfoProvider", {
                attrs: {
                  currentUser: _vm.currentUser,
                  document: _vm.documents,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ attachedToEntities, processing }) {
                      return [
                        _c("RemoveDocumentModal", {
                          attrs: {
                            attachedToEntities: attachedToEntities,
                            processing: processing,
                            fileName: _vm.documents.filename,
                            attachedToInfoHidden: _vm.attachedToInfoHidden,
                          },
                          on: {
                            cancelled: _vm.hideModal,
                            confirmed: _vm.onConfirm,
                            close: _vm.hideModal,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
        ],
        1
      ),
      _vm._t("default", null, { showModal: _vm.showModal }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }